// extracted by mini-css-extract-plugin
module.exports = {"Skeleton":"Skeleton--2rEB6"};